import script from "./DomainAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainAddModal.vue?vue&type=script&setup=true&lang=js"

import "./DomainAddModal.vue?vue&type=style&index=0&id=5ba799e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ba799e4"]])

export default __exports__